// صورت وضعیت قراردادها
import React, { useState, useEffect, useCallback, useRef } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { usePager, CountBadge } from '../../components/paging';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import ContractorRequestDeductions from './ContractorRequestDeductions';
import { ContractInfoBar, StatisticsPanel, PaidHistoryModal, ModifyModal, ReadyModal,
         MoveModal, EvaluationModal } from './ContractorRequestExtras';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';

const toFa   = n => String(n ?? '').replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
const fmtNum = n => (n ? Number(n).toLocaleString('fa-IR') : '•');

// آرایه‌های نوع
const REQUEST_TYPE = ['عادی', 'تعدیل', 'بیمه تمام خطر', 'تفاوت نرخ ارز', 'تاخیر در پرداخت', 'تفاوت بهای مصالح',
  'پیش پرداخت', 'تعلیق', 'جبران آثار کرونا', 'نظارت عالیه', 'وجه التزام', 'تاخیر در تحویل زمین',
  'اسناد سپرده آزاد شده پیش از سررسید', 'مالیات بر ارزش افزوده', 'کسر بهای مصالح',
  'تفاوت سود مالیات بر ارزش افزوده', 'حق الزحمه نگهبانی', 'سایر هزینه ها', 'تفاوت بروزرسانی قرارداد'];
const PREPAYMENT_TYPE  = ['—', 'نقدی', 'مواد و کالای نقدی', 'ملزومات غیر نقدی', 'مواد غیر نقدی', 'کالای غیر نقدی', 'سایر غیر نقدی'];
const TADIL_INDICATOR  = ['—', 'سه ماهه اول', 'سه ماهه دوم', 'سه ماهه سوم', 'سه ماهه چهارم'];
const ACCOUNTING_KIND  = ['هزینه ای', 'تملک'];

const EMPTY = {
  contract_id: 0, contract_disp: '', contractor: '', contract_type: '', contract_cost: 0, begin_date: '', end_date: '',
  serial_no: '', request_no: '', request_type: 0, prepayment_type: 0, tadil_indicator: 0, accounting_kind: 1,
  letter_no: '', letter_date: '', from_date: '', to_date: '',
  request_amount: '', tax_percent: 0, tax_amount: '', insure_percent: 0, insure_amount: '', refrence_amount: '',
  is_final: false, paid_before: false,
  send_to_accounting: false, send_to_budget: false, send_to_evaluation: false,
  evaluation_id: 0, evaluation_title: '', amount_receiver_id: 0, amount_receiver: '',
  tax_refrence_no: '', tax_refrence_date: '', summary_no: '', remark: '', control_ccr_id: 0,
  request_amount_to_now: '',
};

const API = (path, opts = {}) => fetch(`/api/contract${path}`, {
  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
  ...opts,
}).then(jsonOf, netErr);

function Lookup({ label, value, endpoint, onPick, flex = 1, ph = 'جستجو...' }) {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const search = async (text) => { setQ(text); const j = await API(`${endpoint}?q=${encodeURIComponent(text)}`); if (j.ok) { setRows(j.rows); setOpen(true); } };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex, position: 'relative' }}>
      <label style={ui.mlabel}>{label}</label>
      <input value={value || q} onFocus={() => search(q)} onChange={e => search(e.target.value)} placeholder={ph} style={ui.input} />
      {value && <button onClick={() => { onPick({ id: 0, display: '' }); setQ(''); }}
        style={{ position: 'absolute', left: '6px', top: '30px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#c62828', fontSize: '14px' }}>✕</button>}
      {open && rows.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', right: 0, left: 0, background: '#fff', border: '1px solid #e0e0e0',
          borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', zIndex: 900, maxHeight: '220px', overflowY: 'auto', marginTop: '2px' }}>
          {rows.map(r => (
            <div key={r.id} onClick={() => { onPick(r); setOpen(false); setQ(''); }}
              style={{ padding: '8px 10px', cursor: 'pointer', fontSize: '12px', borderBottom: '1px solid #f0f0f0' }}
              onMouseEnter={e => e.currentTarget.style.background = '#e8f0fe'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>{r.display}</div>
          ))}
        </div>
      )}
    </div>
  );
}

function TInput({ label, val, onCh, flex = 1, type = 'text', disabled }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex }}>
      <label style={ui.mlabel}>{label}</label>
      <input type={type} value={val} onChange={e => onCh(e.target.value)} disabled={disabled}
        style={{ ...ui.input, background: disabled ? '#f2f2f2' : '#fff' }} />
    </div>
  );
}

function DateField({ label, val, onCh, flex = 1 }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex }}>
      <label style={ui.mlabel}>{label}</label>
      <JalaliDatePicker value={val} onChange={onCh} placeholder={label} />
    </div>
  );
}

function Chk({ label, checked, onCh }) {
  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: '7px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
      <input type="checkbox" checked={checked} onChange={e => onCh(e.target.checked)} style={{ width: '17px', height: '17px' }} />
      {label}
    </label>
  );
}

// ════════════════════════════════════════════════════════════════════════════
//  بلوک «تا این صورت وضعیت / صورت وضعیت های قبلی / این صورت وضعیت»
//  همهٔ اعداد از /contractor-requests/<id>/summary/ می‌آیند؛ اینجا هیچ محاسبه‌ای نیست.
//  «این صورت وضعیت» باز است؛ «صورت وضعیت های قبلی» با «+» باز می‌شود (پیش‌فرض بسته)؛
//  «تا این صورت وضعیت» (جمع کل) پایین‌تر از هر دو می‌نشیند.
// ════════════════════════════════════════════════════════════════════════════
const SUM_COLS = [
  { k: 'amount',    h: 'مبلغ' },
  { k: 'insure',    h: 'بیمه سهم کارفرما' },
  { k: 'tax',       h: 'مالیات بر ارزش افزوده' },
  { k: 'total',     h: 'جمع کل' },
  { k: 'deduction', h: 'جمع کسورات' },
  { k: 'net',       h: 'خالص' },
];

function SumRow({ title, v, tone, lead }) {
  return (
    <tr style={{ background: tone.bg, fontWeight: 700 }}>
      <td style={{ padding: '7px 10px', textAlign: 'right', color: tone.fg, whiteSpace: 'nowrap', fontSize: '12px' }}>
        {lead}{title}
      </td>
      {SUM_COLS.map(c => (
        <td key={c.k} style={{ padding: '7px 10px', textAlign: 'left', fontSize: '12px',
          fontFamily: 'monospace', color: v[c.k] ? tone.fg : '#bbb' }}>{fmtNum(v[c.k])}</td>
      ))}
    </tr>
  );
}

function SummaryBlock({ s, open, onToggle }) {
  const t = s.totals || {};
  const prev = s.previous_list || [];
  return (
    <div style={{ margin: '10px 4px 4px', border: '1px solid #d8d2c2', borderRadius: '10px',
      overflow: 'hidden', background: '#fff' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: '#0a1628' }}>
            <th style={{ padding: '7px 10px', textAlign: 'right', color: '#C8A84B', fontSize: '12px' }}>
              {s.scope?.request_type_name ? `نوع: ${s.scope.request_type_name}` : 'خلاصه'}
            </th>
            {SUM_COLS.map(c => (
              <th key={c.k} style={{ padding: '7px 10px', textAlign: 'left', color: '#C8A84B', fontSize: '11px' }}>{c.h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {/* ۱) این صورت وضعیت — همیشه باز */}
          <SumRow title="این صورت وضعیت" v={s.rows.this} tone={{ bg: '#fffdf5', fg: '#1a237e' }} />

          {/* ۲) صورت وضعیت های قبلی — با «+» باز می‌شود */}
          <tr style={{ background: '#f6f4ec', fontWeight: 700, cursor: 'pointer' }} onClick={onToggle}>
            <td style={{ padding: '7px 10px', textAlign: 'right', color: '#6a1b9a', fontSize: '12px', whiteSpace: 'nowrap' }}>
              <span style={{ display: 'inline-block', width: '18px', height: '18px', lineHeight: '16px',
                textAlign: 'center', border: '1px solid #6a1b9a', borderRadius: '4px', marginLeft: '6px',
                fontFamily: 'monospace' }}>{open ? '−' : '+'}</span>
              صورت وضعیت های قبلی
              {prev.length > 0 && <span style={{ color: '#888', fontWeight: 400, marginRight: '6px' }}>
                ({toFa(prev.length)} مورد)</span>}
            </td>
            {SUM_COLS.map(c => (
              <td key={c.k} style={{ padding: '7px 10px', textAlign: 'left', fontSize: '12px',
                fontFamily: 'monospace', color: s.rows.previous[c.k] ? '#6a1b9a' : '#bbb' }}>
                {fmtNum(s.rows.previous[c.k])}</td>
            ))}
          </tr>
          {open && prev.map(r => (
            <tr key={r.id} style={{ background: '#fbfaf6' }}>
              <td style={{ padding: '5px 10px 5px 26px', textAlign: 'right', fontSize: '11px', color: '#555' }}>
                ‹ شماره {toFa(r.request_no)}{r.letter_date ? ` — ${r.letter_date}` : ''}
              </td>
              {SUM_COLS.map(c => (
                <td key={c.k} style={{ padding: '5px 10px', textAlign: 'left', fontSize: '11px',
                  fontFamily: 'monospace', color: r[c.k] ? '#555' : '#ccc' }}>{fmtNum(r[c.k])}</td>
              ))}
            </tr>
          ))}
          {open && prev.length === 0 && (
            <tr><td colSpan={7} style={{ padding: '8px 26px', fontSize: '11px', color: '#999', textAlign: 'right' }}>
              صورت وضعیت قبلی‌ای در این دامنه ثبت نشده است</td></tr>
          )}

          {/* ۳) تا این صورت وضعیت — جمع کل، زیر همه */}
          <SumRow title="تا این صورت وضعیت" v={s.rows.to_now} tone={{ bg: '#eef3fb', fg: '#0d47a1' }} />
        </tbody>
      </table>

      {/* نوار پایانی — مبلغ قرارداد، مطالبات، مانده، پرداختی */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '18px', padding: '8px 12px',
        background: '#f0f2f7', fontSize: '12px', fontWeight: 700, borderTop: '1px solid #d8d2c2' }}>
        <span style={{ color: '#1a237e' }}>مبلغ قرارداد: {fmtNum(t.contract_cost)}</span>
        {!!t.contract_claim && <span style={{ color: '#b71c1c' }}>مطالبات: {fmtNum(t.contract_claim)}</span>}
        <span style={{ color: t.remain < 0 ? '#b71c1c' : '#1b5e20' }}>مانده قرارداد: {fmtNum(t.remain)}</span>
        <span style={{ color: '#0d47a1' }}>جمع کل تا این صورت وضعیت: {fmtNum(t.sum_to_now)}</span>
        <span style={{ color: '#1b5e20' }}>خالص تا این صورت وضعیت: {fmtNum(t.net_to_now)}</span>
        <span style={{ color: '#00695c' }}>پرداختی (حواله): {fmtNum(t.paid)}</span>
        <span style={{ color: t.unpaid > 0 ? '#e65100' : '#888' }}>پرداخت نشده: {fmtNum(t.unpaid)}</span>
      </div>
    </div>
  );
}

export default function ContractorRequestList({ user, onBack }) {
  // دکمه‌های فرم FRMCONTRACTORREQUEST — دیدن = دسترسی
  const vbf = useFormButtons('FRMCONTRACTORREQUEST', ["BTNNEW","BTNEDIT","BTNDELETE","BTNOK","BTNDEDUCTION"]);
  const [filterContract, setFilterContract] = useState(null); // {id, display}
  const [data, setData]         = useState([]);
  const pg = usePager();
  const [search, setSearch]     = useState('');
  const [selected, setSelected] = useState(null);
  const [loading, setLoading]   = useState(false);
  const [modal, setModal]       = useState(null);
  const [form, setForm]         = useState(EMPTY);
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState('');
  const [toast, setToast]       = useState('');
  const [tab, setTab]           = useState('main');
  const [dedModal, setDedModal] = useState(null);
  // پیشنهاد محاسبه/حذف خودکار کسورات بعد از ثبت موفق
  const [dedPrompt, setDedPrompt] = useState(null);   // {req_id, action, msg, rows}
  const [rtFilter, setRtFilter]   = useState('');    // فیلتر نوع صورت وضعیت
  const [calc, setCalc]           = useState(null);  // پاسخ /compute/
  const [summary, setSummary]     = useState(null);  // پاسخ /summary/ برای ردیف انتخابی
  const [showPrev, setShowPrev]   = useState(false); // «+» صورت وضعیت های قبلی (پیش‌فرض بسته)
  // ── بخش‌های تکمیلی (contractor_request_extra.py)
  const [spec, setSpec]           = useState(null);  // مشخصات و آمار قرارداد
  const [caps, setCaps]           = useState({});    // دکمه‌های وابسته به کاربر/دستگاه
  const [rtTypes, setRtTypes]     = useState({ types: [], visible: false }); // انواع قابل فیلتر
  const [showStat, setShowStat]   = useState(false); // نمایش آمار
  const [fy, setFy]               = useState(() => String(new Date().toLocaleDateString('fa-IR-u-nu-latn').split('/')[0]));
  const [extra, setExtra]         = useState(null);  // 'paid' | 'modify' | 'ready' | 'move' | 'eval'
  const zemanatShown = useRef(false);               // پیام ضمانتنامه فقط یک بار

  const showToast = m => { setToast(m); setTimeout(() => setToast(''), 3000); };
  const byContract = !!filterContract;

  const cols = [
    { h: 'سریال', k: 'serial_no', w: 70, fa: true },
    ...(byContract ? [] : [
      { h: 'قرارداد', k: 'contract_disp', w: 140, right: true },
      { h: 'پیمانکار', k: 'contractor', w: 170, right: true },
    ]),
    { h: 'نوع', k: 'request_type_name', w: 120, right: true },
    { h: 'صورت وضعیت', k: 'request_no', w: 80, fa: true },
    { h: 'نامه', k: 'letter_no', w: 90 },
    { h: 'تاریخ نامه', k: 'letter_date', w: 95, mono: true },
    { h: 'وضعیت', k: 'is_final', w: 65, final: true },
    { h: 'نوع حساب', k: 'accounting_kind_name', w: 80 },
    { h: 'مبلغ', k: 'request_amount', w: 130, num: true, color: '#1a237e' },
    { h: 'بیمه', k: 'insure_amount', w: 110, num: true, color: '#00695c' },
    { h: 'مالیات', k: 'tax_amount', w: 110, num: true, color: '#6a1b9a' },
    { h: 'جمع', k: 'sum_amount', w: 130, num: true, color: '#1b5e20' },
    // کسورات و خالص فقط وقتی قراردادی فیلتر شده باشد؛
    // بدون قرارداد هر شش ستون کسورات صفرند و پنهان می‌شوند.
    ...(byContract ? [
      { h: 'کسورات', k: 'deduction', w: 120, num: true, color: '#b71c1c' },
      { h: 'خالص', k: 'net_pay', w: 130, num: true, color: '#1b5e20' },
    ] : []),
    { h: 'مبلغ تاکنون', k: 'amount_to_now', w: 130, num: true, color: '#0d47a1' },
    { h: 'جمع تاکنون', k: 'sum_to_now', w: 130, num: true, color: '#0d47a1' },
    { h: 'ذینفع', k: 'amount_receiver', w: 120, right: true },
    // ستون‌های تکمیلی
    { h: 'ضمایم', k: 'scan_count', w: 55, cnt: true },
    { h: 'تعداد واخواهی', k: 'vakhahi_count', w: 80, cnt: true },
    { h: 'حواله', k: 'havaleh_str', w: 170, right: true },
    { h: 'سریال اسناد خزانه', k: 'treasury_serials', w: 130, right: true },
  ];
  const [colW, setColW] = useState(cols.map(c => c.w));
  useEffect(() => { setColW(cols.map(c => c.w)); }, [byContract]);  // eslint-disable-line
  const colWRef = useRef(colW);
  useEffect(() => { colWRef.current = colW; }, [colW]);
  const startResize = useCallback((idx, e) => {
    e.preventDefault(); e.stopPropagation();
    const sx = e.clientX, sw = colWRef.current[idx];
    const onMove = ev => setColW(w => { const n = [...w]; n[idx] = Math.max(40, sw + (sx - ev.clientX)); return n; });
    const onUp = () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); };
    document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp);
  }, []);

  const load = useCallback(async (cid = filterContract?.id || 0, sr = search, page = 1, rt = rtFilter) => {
    setLoading(true); setError('');
    if (page === 1) { setSelected(null); setSummary(null); setShowPrev(false); }
    const j = await API(`/contractor-requests/?contract_id=${cid}&search=${encodeURIComponent(sr)}`
      + `&request_type=${rt}&page=${page}`);
    setLoading(false);
    if (j.ok) setData(prev => pg.merge(prev, j, page)); else setError(j.msg);
  }, [filterContract, search, rtFilter, pg]);

  useEffect(() => { API('/contractor-requests/capabilities/').then(j => { if (j.ok) setCaps(j); }); }, []);

  // فیلتر نوع فقط وقتی قرارداد انتخاب شده و بیش از یک نوع دارد
  useEffect(() => {
    if (!filterContract) { setRtTypes({ types: [], visible: false }); return; }
    API(`/contractor-requests/types/?contract_id=${filterContract.id}`)
      .then(j => { if (j.ok) setRtTypes(j); });
  }, [filterContract]);

  // مشخصات قرارداد — قرارداد فیلتر شده، وگرنه قرارداد ردیف انتخابی
  const specContract = filterContract?.id || selected?.contract_id || 0;
  useEffect(() => {
    if (!specContract) { setSpec(null); return; }
    let live = true;
    API(`/contractor-requests/spec/${specContract}/?financial_year=${fy}`).then(j => {
      if (!live || !j.ok) return;
      setSpec(j.spec);
      if (j.spec.zemanat_warning && !zemanatShown.current) {
        zemanatShown.current = true;
        setToast(j.spec.zemanat_warning);
        setTimeout(() => setToast(''), 5000);
      }
    });
    return () => { live = false; };
  }, [specContract, fy]);

  // ── بلوک سه‌ردیفه: هر بار ردیف انتخابی عوض شود، از بک‌اند خوانده می‌شود
  useEffect(() => {
    setShowPrev(false);
    if (!selected) { setSummary(null); return; }
    let live = true;
    API(`/contractor-requests/${selected.id}/summary/`)
      .then(j => { if (live && j.ok) setSummary(j); });
    return () => { live = false; };
  }, [selected]);

  useEffect(() => { load(0, ''); }, []);   // eslint-disable-line

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));

  // انتخاب قرارداد در فرم → بارگذاری مشخصات + شماره پیشنهادی
  const pickContract = async (r) => {
    if (!r.id) { setForm(f => ({ ...f, contract_id: 0, contract_disp: '', contractor: '', contract_type: '', contract_cost: 0, begin_date: '', end_date: '' })); return; }
    const j = await API(`/contractor-requests/spec/${r.id}/`);
    if (j.ok) {
      const s = j.spec;
      setForm(f => ({ ...f, contract_id: r.id, contract_disp: s.contract_disp, contractor: s.contractor,
        contract_type: s.contract_type, contract_cost: s.contract_cost, begin_date: s.begin_date, end_date: s.end_date }));
    }
    if (modal === 'new') {
      const nj = await API(`/contractor-requests/next-no/?contract_id=${r.id}&request_type=${form.request_type}`);
      if (nj.ok) setForm(f => ({ ...f, serial_no: nj.serial_no }));
      typeChange({}, r.id);
    }
  };

  // با تغییر نوع صورت وضعیت — همه در بک‌اند:
  // در درج: شماره = MAX+1 و «از تاریخ» = روز بعد از آخرین «تا تاریخ»
  // درصدها: نوع ۶ ⇒ صفر؛ اگر صفر بود ⇒ از نوع قرارداد؛ نوع ۲ و ۱۳ ⇒ صفر
  const typeChange = async (patch, contractId) => {
    const nf = { ...form, ...patch };
    const cid = contractId ?? nf.contract_id;
    setForm(nf);
    if (!cid) return;
    const j = await API('/contractor-requests/type-change/', { method: 'POST', body: JSON.stringify({
      contract_id: cid, request_type: nf.request_type, inserting: modal === 'new',
      insure_percent: nf.insure_percent, tax_percent: nf.tax_percent, prepayment_type: nf.prepayment_type }) });
    if (!j.ok) { setError(j.msg); return; }
    setForm(f => ({ ...f,
      insure_percent: j.insure_percent, tax_percent: j.tax_percent,
      ...(j.request_no !== undefined ? { request_no: j.request_no } : {}),
      ...(j.from_date ? { from_date: j.from_date } : {}),
    }));
    compute({ insure_percent: j.insure_percent, tax_percent: j.tax_percent }, 'amount');
  };
  const changeType = v => typeChange({ request_type: v });

  // ── محاسبهٔ مبالغ: تمامِ ریاضیات در بک‌اند.
  //    فرانت فقط مقدار وارد شده و جهت محاسبه (source) را می‌فرستد.
  //    source='amount'  ⇒ کاربر «مبلغ این صورت وضعیت» را زده
  //    source='to_now'  ⇒ کاربر «مبلغ تاکنون» را زده (محاسبهٔ معکوس)
  const calcTimer = useRef(null);
  const compute = useCallback((patch, source) => {
    setForm(f => {
      const nf = { ...f, ...patch };
      clearTimeout(calcTimer.current);
      calcTimer.current = setTimeout(async () => {
        const j = await API('/contractor-requests/compute/', {
          method: 'POST',
          body: JSON.stringify({
            contract_id: nf.contract_id, request_id: (modal === 'edit' && selected) ? selected.id : 0,
            request_no: nf.request_no, request_type: nf.request_type,
            accounting_kind: nf.accounting_kind, paid_before: nf.paid_before,
            tax_percent: nf.tax_percent, insure_percent: nf.insure_percent,
            refrence_amount: nf.refrence_amount,
            request_amount: nf.request_amount, request_amount_to_now: nf.request_amount_to_now,
            source,
          }),
        });
        if (j.ok) {
          setCalc(j);
          setForm(g => ({
            ...g,
            request_amount:        source === 'to_now' ? j.this.amount : g.request_amount,
            request_amount_to_now: source === 'amount' ? j.to_now.amount : g.request_amount_to_now,
            tax_amount:    j.this.tax,
            insure_amount: j.this.insure,
            tax_percent:    j.tax_percent,
            insure_percent: j.insure_percent,
          }));
        }
      }, 300);
      return nf;
    });
  }, [modal, selected]);

  const onAmount      = v => compute({ request_amount: v }, 'amount');
  const onAmountToNow = v => compute({ request_amount_to_now: v }, 'to_now');
  const onTaxPct      = v => compute({ tax_percent: v }, 'amount');
  const onInsPct      = v => compute({ insure_percent: v }, 'amount');
  const onRefAmount   = v => compute({ refrence_amount: v }, 'amount');

  const sumAmount = (Number(form.request_amount) || 0) + (Number(form.tax_amount) || 0) + (Number(form.insure_amount) || 0);

  const openNew  = () => { if (!vbf.can('BTNNEW')) return;
    const base = { ...EMPTY };
    if (filterContract) { base.contract_id = filterContract.id; base.contract_disp = filterContract.display; }
    setForm(base); setError(''); setCalc(null); setTab('main'); setModal('new');
    if (filterContract) setTimeout(() => pickContract(filterContract), 0);
  };
  // پیش از ویرایش پنج بررسی انجام می‌شود؛ در صورت برخورد پیام می‌دهد و
  // فرم بسته نمی‌شود، بلکه در حالت «ویرایش محدود» باز می‌شود.
  const openEdit = async () => { if (!vbf.can('BTNEDIT')) return;
    if (!selected) return;
    setError(''); setCalc(null);
    const j = await API(`/contractor-requests/${selected.id}/edit-check/`);
    if (j && j.ok) {
      if (j.prompt) {
        const yes = window.confirm(j.prompt.msg);
        if (yes) {
          await API(`/contractor-requests/${selected.id}/send-to-accounting/`, {
            method: 'POST',
            body: JSON.stringify({ value: j.prompt.kind === 'send_to_accounting' ? 1 : 0 }),
          });
          load();
        }
      }
      if (!j.edit_allowed && (j.messages || []).length) {
        // فرم باز می‌شود ولی کاربر پیام‌ها را می‌بیند
        setError((j.messages || []).join(' — '));
      }
    }
    setForm({ ...EMPTY, ...selected, request_amount_to_now: selected.amount_to_now });
    setTab('main'); setModal('edit');
  };
  const openDel  = () => { if (!vbf.can('BTNDELETE')) return; if (selected) setModal('delete'); };

  const save = async (confirmDuplicate = false) => {
    setSaving(true); setError('');
    const body = JSON.stringify({ ...form, confirm_duplicate: confirmDuplicate });
    const j = modal === 'new'
      ? await API('/contractor-requests/create/', { method: 'POST', body })
      : await API(`/contractor-requests/${selected.id}/update/`, { method: 'PUT', body });
    setSaving(false);
    // «صورت وضعیت تکراری» در دستگاه ۲:
    // اول پیام، بعد «ثبت صورت وضعیت را تایید می کنید؟»؛ با «بلی» ثبت ادامه پیدا می‌کند.
    if (!j.ok && j.confirm) {
      window.alert(j.msg);
      if (window.confirm(j.confirm)) return save(true);
      return;
    }
    // «ارسال به رسیدگی» بدون نوع سند رسیدگی:
    // پیام نشان داده می‌شود ولی ذخیره انجام شده است (تیک ارسال به رسیدگی برداشته شده).
    if (j.ok && (j.warnings || []).length) window.alert(j.warnings.join('\n'));
    if (j.ok) {
      setModal(null); setSelected(null); showToast(j.msg); load();
      // بعد از ثبت موفق، اگر شرایطش باشد دربارهٔ کسورات می‌پرسد
      if (j.deduction_prompt) setDedPrompt({ ...j.deduction_prompt, req_id: j.id });
    } else setError(j.msg);
  };

  /* پاسخ «بلی» به پیشنهاد کسورات */
  const applyDedPrompt = async () => { if (!vbf.can('BTNOK')) return;
    if (!dedPrompt) return;
    setSaving(true);
    const r = await API(`/contractor-requests/${dedPrompt.req_id}/deductions/auto/`,
      { method: 'POST', body: JSON.stringify({ action: dedPrompt.action }) });
    setSaving(false);
    setDedPrompt(null);
    if (r.ok) { showToast(r.msg); load(); } else setError(r.msg);
  };

  const doDelete = async () => {
    setSaving(true);
    const j = await API(`/contractor-requests/${selected.id}/delete/`, { method: 'DELETE' });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast('حذف شد'); load(); }
    else { setError(j.msg); setModal(null); }
  };

  const toolbar = (
    <>
      <div style={ui.toolBtns}>
        {vbf.can('BTNNEW') && <button onClick={openNew} style={ui.btnNew}>＋ جدید</button>}
        {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected} style={{ ...ui.btnEdit, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✎ ویرایش</button>}
        {vbf.can('BTNDELETE') && <button onClick={openDel} disabled={!selected} style={{ ...ui.btnDel, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✕ حذف</button>}
        {vbf.can('BTNDEDUCTION') && <button onClick={() => selected && setDedModal(selected)} disabled={!selected}
          style={{ ...ui.btnItems, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>💰 کسورات</button>}
      </div>
      <div style={{ ...ui.toolBtns, flexWrap: 'wrap' }}>
        {[
          ['paid',   '📜 سابقه پرداخت', !!selected],
          ['ready',  '✅ تایید شده‌های رسیدگی', true],
          ['modify', '± اصلاحیه', !!selected],
          // رسیدگی — فقط وقتی «شروع رسیدگی» ثبت نشده
          ['eval',   '📝 نوع سند رسیدگی', !!selected && (selected.evaluation_begin_date || '').length !== 10],
          ...(caps.move_to_contract ? [['move', '↪ انتقال به قرارداد دیگر', !!selected]] : []),
        ].map(([k, t, on]) => (
          <button key={k} onClick={() => on && setExtra(k)} disabled={!on}
            style={{ ...ui.btnEdit, padding: '7px 12px', fontSize: '12px', opacity: on ? 1 : 0.4, cursor: on ? 'pointer' : 'default' }}>{t}</button>
        ))}
        <label style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontSize: '12px', whiteSpace: 'nowrap' }}>
          <input type="checkbox" checked={showStat} onChange={e => setShowStat(e.target.checked)} /> آمار
        </label>
        <label style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontSize: '12px' }}>
          سال مالی
          <input value={fy} onChange={e => setFy(e.target.value.replace(/[^0-9]/g, '').slice(0, 4))} style={ui.yearInput} />
        </label>
      </div>
      {/* ── یک جعبهٔ جستجو:
             قرارداد انتخاب نشده → در «قرارداد» و «پیمانکار» می‌گردد
             قرارداد انتخاب شده  → فقط در «توضیحات» می‌گردد                       */}
      {byContract && rtTypes.visible && (
        <select value={rtFilter} onChange={e => { setRtFilter(e.target.value); load(undefined, search, 1, e.target.value); }}
          style={{ ...ui.input, width: '170px', flex: 'none' }} title="نوع صورت وضعیت (rdoReqTypes)">
          <option value="">همه انواع</option>
          {rtTypes.types.map(i => <option key={i} value={i}>{REQUEST_TYPE[i]}</option>)}
        </select>
      )}
      <input value={search} onChange={e => setSearch(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && load(undefined, search, 1)}
        style={{ ...ui.searchInput, flex: 1, minWidth: '200px' }}
        placeholder={byContract ? 'جستجو در توضیحات…' : 'جستجو در قرارداد و پیمانکار…'} />
      {byContract ? (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#0a1628',
          color: '#C8A84B', borderRadius: '14px', padding: '4px 10px', fontSize: '12px', fontWeight: 700,
          maxWidth: '260px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
          title={filterContract.display}>
          قرارداد: {filterContract.display}
          <button onClick={() => { setFilterContract(null); setSearch(''); load(0, '', 1); }}
            style={{ border: 'none', background: 'transparent', color: '#C8A84B', cursor: 'pointer', fontSize: '13px' }}>✕</button>
        </span>
      ) : (
        <button onClick={() => {
            if (!selected) { setError('ابتدا یک ردیف را انتخاب کنید'); return; }
            const c = { id: selected.contract_id, display: selected.contract_disp || String(selected.contract_id) };
            setFilterContract(c); setSearch(''); load(c.id, '', 1);
          }}
          disabled={!selected}
          style={{ ...ui.btnItems, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default', whiteSpace: 'nowrap' }}>
          🔎 فقط این قرارداد
        </button>
      )}
      {loading && <span>⏳</span>}
      <CountBadge shown={data.length} total={pg.total} loading={loading} />
    </>
  );

  const cell = (r, c, sel) => {
    const tc = sel ? '#fff' : '#111';
    if (c.final) return <td style={{ ...ui.td, color: sel ? '#fff' : r.is_final ? '#b71c1c' : '#888', fontWeight: '700' }}>{r.is_final ? 'قطعی' : 'موقت'}</td>;
    if (c.cnt)   return <td style={{ ...ui.td, color: sel ? '#fff' : r[c.k] ? '#1b5e20' : '#ccc', fontWeight: '700' }}>{r[c.k] ? toFa(r[c.k]) : '•'}</td>;
    if (c.num)   return <td style={{ ...ui.tdNum, color: sel ? '#fff' : r[c.k] ? c.color : '#ccc' }}>{fmtNum(r[c.k])}</td>;
    if (c.mono)  return <td style={{ ...ui.td, fontFamily: 'monospace', fontSize: '11px', color: tc }}>{r[c.k] || '•'}</td>;
    if (c.fa)    return <td style={{ ...ui.td, color: tc }}>{r[c.k] ? toFa(r[c.k]) : '•'}</td>;
    return <td style={{ ...ui.td, textAlign: c.right ? 'right' : 'center', fontSize: '11px', color: tc, overflow: 'hidden', textOverflow: 'ellipsis' }} title={r[c.k]}>{r[c.k] || '•'}</td>;
  };

  return (
    <>
      <ListPage user={user} onBack={onBack} title="صورت وضعیت قراردادها" subtitle="بخش قراردادها — سامانه ارجان"
        toolbar={toolbar} error={!modal ? error : ''}
        pager={pg} loading={loading} onMore={p => load(filterContract?.id || 0, search, p)}>
        <ContractInfoBar spec={spec} />
        <table style={{ ...ui.table, tableLayout: 'fixed' }}>
          <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
            <tr>
              {cols.map((c, i) => (
                <th key={i} style={{ ...ui.th, width: colW[i], minWidth: 40, position: 'relative', userSelect: 'none' }}>
                  {c.h}<span onMouseDown={e => startResize(i, e)} style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '4px', cursor: 'col-resize' }} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((r, i) => {
              const sel = selected?.id === r.id;
              // مبلغ منفی → قرمز
              const bg = sel ? '#1a2f50' : r.request_amount < 0 ? '#ffebee' : i % 2 === 0 ? '#fff' : '#fdf6e3';
              return (
                <tr key={r.id} style={{ background: bg, cursor: 'pointer' }}
                  onClick={() => setSelected(sel ? null : r)} onDoubleClick={() => { setSelected(r); setTimeout(openEdit, 0); }}
                  onMouseEnter={e => { if (!sel) e.currentTarget.style.background = '#e8f0fe'; }}
                  onMouseLeave={e => { if (!sel) e.currentTarget.style.background = bg; }}>
                  {cols.map((c, ci) => <React.Fragment key={ci}>{cell(r, c, sel)}</React.Fragment>)}
                </tr>
              );
            })}
          </tbody>
        </table>
        {!loading && data.length === 0 && <div style={ui.empty}>📭 صورت وضعیتی یافت نشد</div>}
        {summary && <SummaryBlock s={summary} open={showPrev} onToggle={() => setShowPrev(v => !v)} />}
        {showStat && selected && <StatisticsPanel reqId={selected.id} financialYear={fy} />}
      </ListPage>

      {(modal === 'new' || modal === 'edit') && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '920px' }} onClick={e => e.stopPropagation()}>
            <div style={ui.mHeader}>
              <div style={ui.mTitle}>{modal === 'new' ? '＋ صورت وضعیت جدید' : `✎ ویرایش — سریال ${toFa(form.serial_no)}`}</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>

            <div style={{ display: 'flex', gap: '4px', padding: '8px 16px 0', background: '#f8f9fa', flexWrap: 'wrap' }}>
              {[['main', 'اطلاعات اصلی'], ['amounts', 'مبالغ'], ['flow', 'ارسال و رسیدگی']].map(([k, t]) => (
                <button key={k} onClick={() => setTab(k)}
                  style={{ padding: '7px 14px', border: 'none', borderRadius: '8px 8px 0 0', cursor: 'pointer', fontFamily: 'inherit', fontSize: '12px', fontWeight: '700',
                    background: tab === k ? '#fff' : 'transparent', color: tab === k ? '#4a148c' : '#888', borderBottom: tab === k ? '2px solid #4a148c' : '2px solid transparent' }}>{t}</button>
              ))}
            </div>

            <div style={ui.mBody}>
              {error && <div style={ui.errBox}>⚠️ {error}</div>}

              {tab === 'main' && (<>
                <div style={ui.row}>
                  <Lookup label="قرارداد" value={form.contract_disp} endpoint="/contractor-requests/lookup/contract/" onPick={pickContract} flex={2} />
                </div>
                <div style={ui.row}>
                  <TInput label="پیمانکار" val={form.contractor} onCh={() => {}} disabled />
                  <TInput label="مبلغ قرارداد" val={fmtNum(form.contract_cost)} onCh={() => {}} disabled flex={0.8} />
                  <TInput label="دوره قرارداد" val={`${form.begin_date || '—'} تا ${form.end_date || '—'}`} onCh={() => {}} disabled flex={1.1} />
                </div>
                <div style={ui.divider} />
                <div style={ui.row}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1.4 }}>
                    <label style={ui.mlabel}>نوع صورت وضعیت</label>
                    <select value={form.request_type} onChange={e => changeType(Number(e.target.value))} style={ui.input}>
                      {REQUEST_TYPE.map((m, i) => <option key={i} value={i}>{m}</option>)}
                    </select>
                  </div>
                  <TInput label="شماره صورت وضعیت" val={form.request_no} onCh={v => F('request_no', v)} type="number" flex={0.8} />
                  <TInput label="سریال (خودکار)" val={form.serial_no} onCh={v => F('serial_no', v)} type="number" flex={0.8} />
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 0.9 }}>
                    <label style={ui.mlabel}>نوع حساب</label>
                    <select value={form.accounting_kind} onChange={e => F('accounting_kind', Number(e.target.value))} style={ui.input}>
                      {ACCOUNTING_KIND.map((m, i) => <option key={i} value={i}>{m}</option>)}
                    </select>
                  </div>
                </div>
                {form.request_type === 1 && (
                  <div style={ui.row}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                      <label style={ui.mlabel}>شاخص تعدیل</label>
                      <select value={form.tadil_indicator} onChange={e => F('tadil_indicator', Number(e.target.value))} style={ui.input}>
                        {TADIL_INDICATOR.map((m, i) => <option key={i} value={i}>{m}</option>)}
                      </select>
                    </div>
                  </div>
                )}
                {form.request_type === 6 && (
                  <div style={ui.row}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                      <label style={ui.mlabel}>نوع پیش پرداخت</label>
                      <select value={form.prepayment_type} onChange={e => F('prepayment_type', Number(e.target.value))} style={ui.input}>
                        {PREPAYMENT_TYPE.map((m, i) => <option key={i} value={i}>{m}</option>)}
                      </select>
                    </div>
                  </div>
                )}
                <div style={ui.row}>
                  <TInput label="شماره نامه" val={form.letter_no} onCh={v => F('letter_no', v)} />
                  <DateField label="تاریخ نامه" val={form.letter_date} onCh={v => F('letter_date', v)} />
                  <DateField label="از تاریخ (دوره کارکرد)" val={form.from_date} onCh={v => F('from_date', v)} />
                  <DateField label="تا تاریخ (دوره کارکرد)" val={form.to_date} onCh={v => F('to_date', v)} />
                </div>
                <div style={ui.row}>
                  <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <Chk label="قطعی" checked={form.is_final} onCh={v => F('is_final', v)} />
                    <Chk label="پرداخت قبلی" checked={form.paid_before} onCh={v => F('paid_before', v)} />
                  </div>
                </div>
              </>)}

              {tab === 'amounts' && (<>
                <div style={ui.row}>
                  <TInput label="مبلغ صورت وضعیت (ریال)" val={form.request_amount} onCh={onAmount} type="number" flex={1.4} />
                  {/* محاسبهٔ معکوس از مبلغ تاکنون */}
                  <TInput label="مبلغ تاکنون (ریال)" val={form.request_amount_to_now} onCh={onAmountToNow} type="number" flex={1.4} />
                  <TInput label="مبلغ مأخذ" val={form.refrence_amount} onCh={onRefAmount} type="number" />
                </div>
                <div style={ui.row}>
                  <TInput label="درصد بیمه" val={form.insure_percent} onCh={onInsPct} type="number" flex={0.6} />
                  <TInput label="بیمه سهم دولت (ریال)" val={form.insure_amount} onCh={v => F('insure_amount', v)} type="number" />
                  <TInput label="درصد مالیات" val={form.tax_percent} onCh={onTaxPct} type="number" flex={0.6} />
                  <TInput label="مالیات بر ارزش افزوده (ریال)" val={form.tax_amount} onCh={v => F('tax_amount', v)} type="number" />
                </div>
                <div style={{ background: '#f0f2f7', borderRadius: '10px', padding: '12px 16px', display: 'flex', gap: '20px', flexWrap: 'wrap', fontSize: '13px', fontWeight: '700' }}>
                  {/* اعداد از پاسخ /compute/ می‌آیند — هیچ محاسبه‌ای در فرانت نیست */}
                  <span style={{ color: '#1a237e' }}>جمع: {fmtNum(calc ? calc.this.total : sumAmount)}</span>
                  <span style={{ color: '#b71c1c' }}>کسورات: {fmtNum(calc ? calc.this.deduction : selected?.deduction)}</span>
                  <span style={{ color: '#1b5e20' }}>خالص: {fmtNum(calc ? calc.this.net : sumAmount - (selected?.deduction || 0))}</span>
                  <span style={{ color: '#6a1b9a' }}>جمع قبل: {fmtNum(calc ? calc.previous.total : selected?.sum_before)}</span>
                  <span style={{ color: '#0d47a1' }}>جمع تاکنون: {fmtNum(calc ? calc.to_now.total : selected?.sum_to_now)}</span>
                  {calc && form.request_type === 0 && (
                    <span style={{ color: calc.remain < 0 ? '#b71c1c' : '#1b5e20' }}>
                      مانده قرارداد: {fmtNum(calc.remain)}</span>
                  )}
                </div>
                {modal === 'edit' && (
                  <div style={{ marginTop: '10px', fontSize: '12px', color: '#888' }}>
                    برای ثبت کسورات، پس از بستن این پنجره دکمهٔ «💰 کسورات» را بزنید.
                  </div>
                )}
              </>)}

              {tab === 'flow' && (<>
                <div style={ui.row}>
                  <div style={{ display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap' }}>
                    <Chk label="ارسال به تنظیم حساب" checked={form.send_to_accounting} onCh={v => F('send_to_accounting', v)} />
                    <Chk label="ارسال به بودجه" checked={form.send_to_budget} onCh={v => F('send_to_budget', v)} />
                    <Chk label="ارسال به رسیدگی" checked={form.send_to_evaluation} onCh={v => F('send_to_evaluation', v)} />
                  </div>
                </div>
                <div style={ui.row}>
                  <Lookup label="نوع سند رسیدگی" value={form.evaluation_title} endpoint="/contractor-requests/lookup/evaluation/"
                    onPick={r => setForm(f => ({ ...f, evaluation_id: r.id, evaluation_title: r.display }))} />
                  <Lookup label="ذینفع" value={form.amount_receiver} endpoint="/contractor-requests/lookup/amount-receiver/"
                    onPick={r => setForm(f => ({ ...f, amount_receiver_id: r.id, amount_receiver: r.display }))} />
                </div>
                <div style={ui.row}>
                  <TInput label="شماره رهگیری مالیاتی" val={form.tax_refrence_no} onCh={v => F('tax_refrence_no', v)} />
                  <DateField label="تاریخ رهگیری مالیاتی" val={form.tax_refrence_date} onCh={v => F('tax_refrence_date', v)} />
                  <TInput label="شماره نماینده" val={form.summary_no} onCh={v => F('summary_no', v)} type="number" flex={0.7} />
                </div>
                <div style={ui.row}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                    <label style={ui.mlabel}>توضیحات</label>
                    <input value={form.remark} onChange={e => F('remark', e.target.value)} style={ui.input} />
                  </div>
                </div>
              </>)}
            </div>

            <div style={ui.mFooter}>
              <button onClick={() => { setModal(null); setError(''); }} style={ui.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={() => save(false)} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : '💾 ذخیره'}</button>}
            </div>
          </div>
        </div>
      )}

      {modal === 'delete' && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '460px' }} onClick={e => e.stopPropagation()}>
            <div style={{ ...ui.mHeader, background: 'linear-gradient(135deg,#b71c1c,#c62828)' }}>
              <div style={ui.mTitle}>⚠️ تأیید حذف</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{ ...ui.mBody, textAlign: 'center', padding: '26px' }}>
              <div style={{ fontSize: '34px', marginBottom: '10px' }}>🗑️</div>
              صورت وضعیت {selected?.request_type_name} شماره {toFa(selected?.request_no)}<br />
              مبلغ {fmtNum(selected?.request_amount)} ریال
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => setModal(null)} style={ui.btnCancel}>خیر</button>
              {vbf.can('BTNDELETE') && <button onClick={doDelete} disabled={saving} style={{ ...ui.btnSave, background: '#b71c1c' }}>{saving ? '⏳...' : 'بله، حذف'}</button>}
            </div>
          </div>
        </div>
      )}

      {dedModal && (
        <ContractorRequestDeductions reqId={dedModal.id} sumAmount={dedModal.sum_amount}
          title={`${dedModal.request_type_name} شماره ${toFa(dedModal.request_no)}`}
          onClose={() => setDedModal(null)} onChanged={() => load()} />
      )}


      {/* پرسش کسورات */}
      {dedPrompt && (
        <div style={ui.overlay} onClick={() => setDedPrompt(null)}>
          <div style={{ ...ui.modal, maxWidth: '500px' }} onClick={e => e.stopPropagation()}>
            <div style={{ ...ui.mHeader, background: 'linear-gradient(135deg,#e65100,#ef6c00)' }}>
              <div style={ui.mTitle}>انتخاب کنید</div>
              <button onClick={() => setDedPrompt(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{ ...ui.mBody, padding: '20px' }}>
              <div style={{ textAlign: 'center', fontSize: '14px', lineHeight: 2, marginBottom: '10px' }}>
                {String(dedPrompt.msg || '').split('\n').map((ln, i) => <div key={i}>{ln}</div>)}
              </div>
              {dedPrompt.action === 'calculate' && dedPrompt.rows && (
                <table style={{ ...ui.table, marginTop: '8px' }}>
                  <thead><tr>
                    <th style={ui.th}>عنوان کسورات</th><th style={ui.th}>درصد</th><th style={ui.th}>مبلغ</th>
                  </tr></thead>
                  <tbody>
                    {dedPrompt.rows.map((r, i) => (
                      <tr key={i}>
                        <td style={ui.td}>{r.title}</td>
                        <td style={ui.tdNum}>{toFa(r.percent)}</td>
                        <td style={ui.tdNum}>{Number(r.amount || 0).toLocaleString('fa-IR')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => setDedPrompt(null)} style={ui.btnCancel}>خیر</button>
              {vbf.can('BTNOK') && <button onClick={applyDedPrompt} disabled={saving} style={ui.btnSave}>
                {saving ? '⏳...' : 'بلی'}
              </button>}
            </div>
          </div>
        </div>
      )}
      {/* ── بخش‌های تکمیلی ── */}
      {extra === 'paid' && selected && <PaidHistoryModal req={selected} onClose={() => setExtra(null)} />}
      {extra === 'modify' && selected && (
        <ModifyModal req={selected} onClose={() => setExtra(null)}
          onDone={m => { setExtra(null); showToast(m); load(); }} />)}
      {extra === 'ready' && (
        <ReadyModal contractId={filterContract?.id || 0} Lookup={Lookup} onClose={() => setExtra(null)}
          onDone={j => {
            setExtra(null); showToast(j.msg); load();
            if (j.deduction_prompt) setDedPrompt({ ...j.deduction_prompt, req_id: j.id });
          }} />)}
      {extra === 'move' && selected && (
        <MoveModal req={selected} Lookup={Lookup} onClose={() => setExtra(null)}
          onDone={m => { setExtra(null); showToast(m); load(); }} />)}
      {extra === 'eval' && selected && (
        <EvaluationModal req={selected} Lookup={Lookup} onClose={() => setExtra(null)}
          onDone={m => { setExtra(null); showToast(m); load(); }} />)}
      {toast && <div style={ui.toast}>{toast}</div>}
    </>
  );
}
